/** The id of a day column of the team week table, e.g. `T_status_2026-10-131`. */
export const makeWeeklyTableId = (
  headers: string[],
  col: string,
  index: number
) => {
  const key = `${headers[index]}_status_${col}${index}`;
  return key;
};

/** The day letter a `makeWeeklyTableId` id starts with. */
export const getDatNameFromId = (id: string) => {
  return id.split("_")[0];
};
